import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import useFeatureFlag from 'hooks/useFeatureFlag';
import FlowContextDataSlideOut from 'components/FlowBuilder/FlowFileUpload/FlowContextDataSlideOut/FlowContextDataSlideOut';
import ContextDataSlideOut from './ContextDataSlideOut';

type ContextDataSlideOutContextValue = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
};

const ContextDataSlideOutContext = createContext<ContextDataSlideOutContextValue | null>(null);

export const useContextDataSlideOut = (): ContextDataSlideOutContextValue | null =>
  useContext(ContextDataSlideOutContext);

type ContextDataSlideOutProviderProps = {
  children: React.ReactNode;
};

export const ContextDataSlideOutProvider: React.FC<ContextDataSlideOutProviderProps> = ({ children }) => {
  const { flags } = useFeatureFlag();
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((prev) => !prev), []);

  const value = useMemo(
    () => ({
      isOpen,
      open,
      close,
      toggle,
    }),
    [isOpen, open, close, toggle],
  );

  return (
    <ContextDataSlideOutContext.Provider value={value}>
      {children}
      {flags['tx_context-data-queue-v2'] ? (
        <FlowContextDataSlideOut isOpen={isOpen} onClickClose={close} />
      ) : (
        <ContextDataSlideOut isOpen={isOpen} onClickClose={close} />
      )}
    </ContextDataSlideOutContext.Provider>
  );
};
